import type { LocaleCode } from "@homeinstead/locale";

import { isPostalCodeFormatValidForLocale } from "@homeinstead/locale";

/**
 * True when the typed value matches the active locale's postal code format
 * (US ZIP, Canadian postal code, or Eircode), so offices are only fetched
 * once the value could plausibly resolve to a location.
 */
function isPostalCodeFormatValid(
  value: string,
  localeCode: LocaleCode,
): boolean {
  return isPostalCodeFormatValidForLocale(value.trim(), localeCode);
}

export { isPostalCodeFormatValid };
